<hbox class="rule-item">{$rule.name}</hbox>

<script lang="ts">
  import { FilterRuleAction } from "../../../logic/Mail/FilterRules/FilterRuleAction";

  export let rule: FilterRuleAction;
</script>

<style>
</style>
